// @flow
import * as React from 'react';
import { sprintf } from 'sprintf-js';
import Box from 'components/Box';
import { PrimaryButton, LinkButton } from 'components/Button';
import ShowModalContainer from 'containers/ShowModalContainer';
import { SmallTile } from 'components/Tile';
import { H4, BodySmall } from 'components/Text';
import {
  LISTING_TYPE_HUMAN_NAME_MAP_TITLE,
  LISTING_TYPE_PLURAL_HUMAN_NAME_MAP
} from 'utils/constants';
import { trackClicked } from 'utils/analytics';
import { gutterWidth } from '../theme';

const ListingSignupCta = ({
  listingUrl,
  type
}: {
  listingUrl: string,
  type: string
}) => (
  <Box data-qa-id="job-listing-signup-promo">
    <SmallTile blueBorder p={[gutterWidth / 2, null, gutterWidth]}>
      <H4>{getText('Join Idealist')}</H4>
      <BodySmall>
        {sprintf(
          getText(
            'Sign up today to save your favorite %(type)s and get email alerts when new ones are posted.'
          ),
          {
            type: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP[type]
          }
        )}
      </BodySmall>
      <ShowModalContainer
        render={showModal => (
          <>
            <Box mt={36} mx="auto">
              <PrimaryButton
                onClick={e => {
                  e.preventDefault();
                  trackClicked(
                    `${
                      LISTING_TYPE_HUMAN_NAME_MAP_TITLE[type]
                    } Listing CTA: Sign Up`
                  );
                  showModal('SIGNUP', { redirectTo: listingUrl });
                }}
                data-qa-id="listing-promo-signup-link"
              >
                {getText('Get Started')}
              </PrimaryButton>
            </Box>
            <Box mt={24} mx="auto">
              <LinkButton
                onClick={() => {
                  trackClicked(
                    `${
                      LISTING_TYPE_HUMAN_NAME_MAP_TITLE[type]
                    } Listing CTA: Log In`
                  );
                  showModal('LOGIN', {
                    redirectTo: listingUrl,
                    manualLogin: true
                  });
                }}
                data-qa-id="listing-promo-login-link"
              >
                <BodySmall styleAs="h5">
                  {getText('Already a user? Log in')}
                </BodySmall>
              </LinkButton>
            </Box>
          </>
        )}
      />
    </SmallTile>
  </Box>
);

export default ListingSignupCta;
